import { useLang } from 'hooks/lang';

import { Column, Row, IconButton } from 'components/Blocks';
import { PropertyWithIcon } from 'components/PropertyWithIcon';

import { ExternalLinkIcon, FolderIcon } from 'components/Icons';

import { truncateText } from 'utils/text';

import { InvoiceTabProps } from './types';

export function InvoiceSampleIds({ invoice }: InvoiceTabProps): JSX.Element {
  const { t } = useLang();

  const entries = invoice.entries.filter(({ sampleIds }) => sampleIds?.length);

  return (
    <Column gap="6">
      <h6 className="text-center font-semibold">{t('sample-ids')}</h6>

      {entries.map(({ sampleIds, project, package: packageData, projectInvoice }) => (
        <Row key={projectInvoice ?? packageData?.id} justifyContent="space-between">
          <PropertyWithIcon
            icon={<FolderIcon />}
            name={truncateText((project?.name || packageData?.name) as string, 60)}
            alignItems="center"
            value={<span className="text-success-light">{sampleIds?.join(', ')}</span>}
          />

          {project ? (
            <IconButton
              to="projectProfile"
              params={{ projectId: project.id }}
              linkTarget={project.id}
            >
              <ExternalLinkIcon />
            </IconButton>
          ) : (
            <IconButton
              to="packageProfile"
              params={{ packageId: packageData!.id }}
              linkTarget={packageData!.id}
            >
              <ExternalLinkIcon />
            </IconButton>
          )}
        </Row>
      ))}
    </Column>
  );
}
